<template>
    <div class="orderCard__wrapper">
        <OrderCard v-for="order in filteredOrders" :order="order" :key="order.id"/>
        <template v-if="status==='archive' && archive">
            <div class="archive__error" role="alert" v-if="archive.error">
                Не удалось загрузить заказы
                <button type="button" @click="$emit('retry')">Повторить</button>
            </div>
            <div class="archive__more" role="status" aria-live="polite" v-else-if="archive.loading && filteredOrders.length">
                <span class="ring" aria-hidden="true"><span></span><span></span><span></span><span></span></span>
                Загружаем ещё заказы…
            </div>
            <div class="archive__end" v-else-if="archive.loaded && !archive.hasMore && filteredOrders.length">
                Это все заказы в архиве
            </div>
            <div class="archive__empty" v-else-if="archive.loaded && !archive.hasMore && !filteredOrders.length">
                <i class="far fa-folder-open" aria-hidden="true"></i>
                В архиве пока нет заказов
            </div>
            <div class="archive__sentinel" ref="sentinel" aria-hidden="true"></div>
        </template>
    </div>
</template>
<script>
import OrderCard from './OrderCard.vue'

// The next archive page is requested this far before the end of the list.
const PRELOAD_MARGIN = '0px 0px 300px 0px';

export default {
    props: ['status', 'filteredOrders', 'archive'],
    components: {OrderCard},
    data(){
        return {
            observer: null,
        }
    },
    computed: {
        canLoadMore(){
            return this.status === 'archive' && !!this.archive
                && this.archive.loaded && this.archive.hasMore && !this.archive.loading && !this.archive.error;
        }
    },
    watch: {
        // Re-observing reports the sentinel's current position, so a page that does not fill the screen
        // still leads to the next request.
        canLoadMore(){
            this.$nextTick(this.observe);
        }
    },
    mounted(){
        this.observe();
    },
    beforeDestroy(){
        this.disconnect();
    },
    methods: {
        observe(){
            this.disconnect();
            if (!this.canLoadMore || !this.$refs.sentinel || typeof IntersectionObserver === 'undefined') {
                return;
            }
            this.observer = new IntersectionObserver(entries => {
                if (entries.some(entry => entry.isIntersecting) && this.canLoadMore) {
                    this.disconnect();
                    this.$emit('load-more');
                }
            }, {rootMargin: PRELOAD_MARGIN});
            this.observer.observe(this.$refs.sentinel);
        },
        disconnect(){
            if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.orderCard__wrapper{
    margin-bottom: 49px;
}
.archive__more, .archive__end, .archive__empty, .archive__error{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 16px;
    font-family: 'Roboto', sans-serif;
    color: #9D9D9D;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
}
.archive__empty{
    flex-direction: column;
    padding: 64px 16px;
    font-size: 14px;
    line-height: 20px;
    i{
        font-size: 32px;
        color: #C4C4C4;
    }
}
.archive__error{
    flex-direction: column;
    gap: 4px;
    button{
        border: 0;
        background: none;
        color: #03A9F4;
        font-family: 'Roboto', sans-serif;
        font-weight: 500;
        font-size: 12px;
        line-height: 24px;
        letter-spacing: 1.25px;
        text-transform: uppercase;
        // 44px touch target; the negative margin keeps the row as tall as the 32px visual button.
        min-height: 44px;
        padding: 10px 12px;
        margin: -6px 0;
        cursor: pointer;
    }
}
.archive__sentinel{
    height: 1px;
}
.ring{
    display: inline-block;
    position: relative;
    width: 24px;
    height: 24px;
    span{
        box-sizing: border-box;
        position: absolute;
        width: 20px;
        height: 20px;
        margin: 2px;
        border: 3px solid #03A9F4;
        border-radius: 50%;
        border-color: #03A9F4 transparent transparent transparent;
        animation: archive-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    }
    span:nth-child(1){
        animation-delay: -0.45s;
    }
    span:nth-child(2){
        animation-delay: -0.3s;
    }
    span:nth-child(3){
        animation-delay: -0.15s;
    }
}
@keyframes archive-ring{
    0%{
        transform: rotate(0deg);
    }
    100%{
        transform: rotate(360deg);
    }
}
@media (prefers-reduced-motion: reduce){
    .ring span{
        animation-duration: 3s;
    }
}
</style>
